import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, exhaustMap, of, switchMap, withLatestFrom } from 'rxjs';
import { ViolationsActions } from '../state/violations/violations.actions';
import { violationsFeature } from '../state/violations/violations.feature';
import { ViolationsService } from '../../services/violations.service';

export const startLoadViolations$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(ViolationsActions.startLoadViolations),
      exhaustMap(({ filters }) => [
        ViolationsActions.getViolations({ filters }),
      ]),
    ),
  { functional: true },
);

export const getViolations$ = createEffect(
  (
    actions$ = inject(Actions),
    store = inject(Store),
    violationsService = inject(ViolationsService),
  ) =>
    actions$.pipe(
      ofType(ViolationsActions.getViolations),
      withLatestFrom(store.select(violationsFeature.selectViolationsState)),
      switchMap(([{ filters }, { nextCursor, hasMore, limit }]) => {
        if (!hasMore) {
          return EMPTY;
        }
        return violationsService.getViolations(nextCursor, limit, filters).pipe(
          switchMap(({ items, nextCursor: newCursor, hasMore: newHasMore }) => [
            ViolationsActions.getViolationsSuccess({
              violations: items,
              nextCursor: newCursor,
              hasMore: newHasMore,
            }),
          ]),
          catchError(() =>
            of(
              ViolationsActions.getViolationsFail({
                error: 'Failed to load violations.',
              }),
            ),
          ),
        );
      }),
    ),
  { functional: true },
);
